export default __webpack_public_path__ + "static/media/prize-1-bm.851c32ea.webp";